var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ofType } from "redux-observable";
import { from, of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectAllExistingBuildingInfo } from "../../../../selectors/selectExistingBuildingInfo";
import { selectExpansionInfo } from "../../../../selectors/selectExpansionInfo";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionOngoingPurchasePremiumDeselect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { actionBuildingsStartPlacement, TypeActionBuildings, } from "../actionBuildings";
export var epicBuildingPurchaseConfirmed = function (action$, state$) {
    return action$.pipe(ofType(TypeActionBuildings.PurchaseConfirmed), switchMap(function (action) {
        var state = state$.value;
        var building = action.building, premium = action.premium;
        var _a = selectExpansionInfo(state), baseSetup = _a.baseSetup, unlockedExpansionIds = _a.unlockedExpansionIds;
        var existingBaseBuildings = selectAllExistingBuildingInfo(state);
        var autoPlacementPosition = utilBuildings.getAutoPlacementPosition(building.balancing, baseSetup, unlockedExpansionIds || [], existingBaseBuildings);
        var data = __assign({}, building, { proto: __assign({}, building.proto, { flipped: autoPlacementPosition.flipped, posX: autoPlacementPosition.x, posY: autoPlacementPosition.y }) });
        if (premium) {
            if (state.ongoingPurchase.premium.isConfirmed) {
                return from([
                    actionBuildingsStartPlacement(data, premium),
                    actionOngoingPurchasePremiumDeselect(),
                ]);
            }
            return of(actionOngoingPurchasePremiumDeselect());
        }
        return of(actionBuildingsStartPlacement(data, premium));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingPurchaseConfirmed.ts
// module id = 2047
// module chunks = 3